"use client"

import { Images } from "@/constants/images"
import { useFooterSettings } from "@/hook/useFooterSettings"
import Image from "next/image"
import Link from "next/link"

interface AddressSectionProps {
  title?: string
  className?: string
  locale: string
}

export const AddressSection: React.FC<AddressSectionProps> = ({ title = "", className = "", locale }) => {
  const { settings } = useFooterSettings(locale)

  const displayHotline = settings?.hotline || "+420 222 132 119"
  const displayAddress = settings?.address || "V lužích 735/6, Libuš, 142 00 Praha"
  const displayEmail = settings?.email || "info@tamda.eu"
  const googleMapsUrl = settings?.googleMapUrl || "#"

  return (
    <div className={`flex flex-col gap-[15px] ${className}`}>
      <h3 className="text-xl leading-[22px] font-bold text-[#18af4e]">{title}</h3>
      <ul className="flex flex-col">
        {displayAddress && (
          <li className="flex items-center text-[#52526C] ">
            <Image src={Images.iconLocationStore} alt="icon-location" className="w-4 h-4" />
            <Link
              href={googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-base sm:leading-[24px] leading-[26px] font-semibold py-[3px] pl-2.5 hover-underline-left-to-right"
            >
              {displayAddress}
            </Link>
          </li>
        )}
        {displayHotline && (
          <li className="flex items-center text-[#52526C]">
            <Image src={Images.iconPhone} alt="icon-phone" className="w-4 h-4" />
            <Link
              href={`tel:${displayHotline}`}
              className="text-base sm:leading-[24px] leading-[26px] font-semibold py-[3px] pl-2.5 hover-underline-left-to-right"
            >
              {displayHotline}
            </Link>
          </li>
        )}
        {displayEmail && (
          <li className="flex items-center text-[#52526C]">
            <Image src={Images.iconEmail} alt="icon-email" className="w-4 h-4" />
            <Link
              href={`mailto:${displayEmail}`}
              className="text-base sm:leading-[24px] leading-[26px] font-semibold py-[3px] pl-2.5 hover-underline-left-to-right"
            >
              {displayEmail}
            </Link>
          </li>
        )}
      </ul>
    </div>
  )
}
